(() => {
  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

  const cards = document.querySelectorAll('[data-hiw-card]');
  if (!cards.length) return;

  const setUp = (card) => {
    const video = card.querySelector('[data-hiw-video]');
    if (!video) return null;
    const poster = card.querySelector('.hiw-card__poster');

    const skipRaw = parseFloat(card.dataset.hiwSkip);
    // Default to 0.6s if no explicit skip is set, to bypass typical fade-ins
    const skip = isFinite(skipRaw) && skipRaw > 0 ? skipRaw : 0.6;

    let primed = false;
    let frameCaptured = false;

    const isMostlyBlack = (ctx, w, h) => {
      // Sample a few pixels — if average brightness is near zero, the seek caught a black frame
      try {
        const sx = Math.floor(w / 4);
        const sy = Math.floor(h / 4);
        const sw = Math.max(1, Math.floor(w / 2));
        const sh = Math.max(1, Math.floor(h / 2));
        const data = ctx.getImageData(sx, sy, sw, sh).data;
        let total = 0;
        const step = 16; // skip pixels for speed
        let count = 0;
        for (let i = 0; i < data.length; i += 4 * step) {
          total += (data[i] + data[i + 1] + data[i + 2]) / 3;
          count++;
        }
        return count > 0 && total / count < 12; // avg below ~12/255
      } catch (_) {
        return false;
      }
    };

    const captureFrame = () => {
      if (frameCaptured || !poster) return;
      if (!video.videoWidth || video.readyState < 2) return;
      try {
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        if (isMostlyBlack(ctx, canvas.width, canvas.height)) return; // retry later
        const dataUrl = canvas.toDataURL('image/jpeg', 0.82);
        poster.src = dataUrl;
        frameCaptured = true;
      } catch (e) {
        // Tainted canvas / CORS — keep existing poster
      }
    };

    const requestCapture = () => {
      // Wait for an actual rendered frame, not just the seeked event firing
      if ('requestVideoFrameCallback' in HTMLVideoElement.prototype) {
        video.requestVideoFrameCallback(() => captureFrame());
      } else {
        setTimeout(captureFrame, 200);
      }
    };

    const primeSources = () => {
      if (primed) return;
      primed = true;
      card.classList.add('hiw-card--video-ready');
      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.setAttribute('src', source.getAttribute('data-src'));
        source.removeAttribute('data-src');
      });
      video.preload = 'auto';
      video.load();

      const onLoaded = () => {
        if (skip > 0 && isFinite(video.duration) && video.duration > skip) {
          try { video.currentTime = skip; } catch (e) {}
        }
        video.removeEventListener('loadeddata', onLoaded);
      };
      video.addEventListener('loadeddata', onLoaded);

      video.addEventListener('seeked', requestCapture);
      // Backup: retry once the video can actually play (frames are decoded)
      video.addEventListener('canplay', requestCapture);
    };

    const playVideo = () => {
      if (skip > 0 && video.readyState >= 1 && video.currentTime < skip) {
        try { video.currentTime = skip; } catch (e) {}
      }
      const p = video.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
      card.classList.add('hiw-card--playing');
      // Last-resort capture — once playback has actually started, we know frames are real
      if (!frameCaptured) requestCapture();
    };

    card.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      primeSources();
      playVideo();
    });

    card.addEventListener('mouseleave', () => {
      if (!isDesktop()) return;
      video.pause();
      try { video.currentTime = skip; } catch (e) {}
      card.classList.remove('hiw-card--playing');
    });

    card.addEventListener('click', () => {
      if (isDesktop()) return;
      primeSources();
      if (video.paused) playVideo();
      else { video.pause(); card.classList.remove('hiw-card--playing'); }
    });

    return primeSources;
  };

  const primers = new Map();
  cards.forEach((card) => {
    const prime = setUp(card);
    if (prime) primers.set(card, prime);
  });

  // Pre-buffer when the section approaches the viewport — keeps initial page load fast
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const prime = primers.get(entry.target);
          if (prime) prime();
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '600px 0px 600px 0px' });
    cards.forEach((card) => io.observe(card));
  }
})();
